import React from "react";
import MasterLayout from "components/Layout/MasterLayout";
import Dashboard from "features/Dashboard/components/Dashboard";
import { Loader } from "components/FormComponents/Loader/Loader";
import Alerts from "features/Alerts/components/Alerts";
import Reports from "features/Reports/components/Reports";
import Faculty from "features/Faculty/components/Faculty";
import Activity from "features/Activity/components/Activity";
import Administration from "features/Administration/components/Administration";

const LazyViewMyList = React.lazy(
  async () => await import("features/Faculty/components/ViewMyList"),
);

const LazyFacultyTypeSelection = React.lazy(
  async () => await import("features/Faculty/components/FacultyTypeSelection"),
);

const LazyAddMultipleFaculty = React.lazy(
  async () => await import("features/Faculty/components/AddMultipleFaculty"),
);

const LazyFacultyRequestProfile = React.lazy(
  async () => await import("features/Faculty/components/FacultyRequestProfile"),
);

const LazyAddNonHCPAndPatient = React.lazy(
  async () => await import("features/Faculty/components/AddNonHCPAndPatient"),
);

const LazySelectBrandOrMedicalActivityType = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/AddActivity/SelectBrandOrMedicalActivityType"
    ),
);

const LazyMedicalActivity = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/AddActivity/MedicalActivity/MedicalActivity"
    ),
);

const LazySearchVenueCaterer = React.lazy(
  async () =>
    await import("features/Administration/components/SearchVenueCaterer"),
);

const LazyAddEditVenueCaterer = React.lazy(
  async () =>
    await import("features/Administration/components/AddEditVenueCaterer"),
);

const LazyPaymentRequest = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PaymentManagmentTools/PaymentRequest"
    ),
);

const LazyActivityMeetings = React.lazy(
  async () => await import("features/Activity/components/ActivityMeetings"),
);
const LazySendCorrespondence = React.lazy(
  async () => await import("features/Activity/components/SendCorrespondence"),
);
const LazyActivityMap = React.lazy(
  async () =>
    await import("features/Activity/components/ActivityTools/ActivityMap"),
);

const LazyActivityHistory = React.lazy(
  async () => await import("features/Activity/components/ActivityHistory"),
);

const LazyCheckStatus = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PaymentManagmentTools/CheckStatus"
    ),
);

const LazyReportCriteria = React.lazy(
  async () => await import("features/Reports/components/ReportCriteria"),
);

const LazyMyScheduledReports = React.lazy(
  async () => await import("features/Reports/components/MyScheduledReports"),
);

const LazyBudgetApprovalAlerts = React.lazy(
  async () => await import("features/Alerts/components/BudgetApprovalAlert"),
);

const LazyAdditionalCompensationAlerts = React.lazy(
  async () =>
    await import("features/Alerts/components/AdditionalCompensationAlerts"),
);

const LazyFacultyApprovalAlert = React.lazy(
  async () => await import("features/Alerts/components/FacultyApprovalAlert"),
);

const LazyFacultyCVAlerts = React.lazy(
  async () => await import("features/Alerts/components/FacultyCVAlert"),
);

const LazyAdvisoryBoardSingleActivityAlerts = React.lazy(
  async () =>
    await import("features/Alerts/components/AdvisoryBoardSingleActivityAlert"),
);

const LazyApprovedFacultyRequestAlert = React.lazy(
  async () =>
    await import("features/Alerts/components/ApprovedFacultyRequestAlert"),
);

const LazyInvitationTemplateApprovalAlerts = React.lazy(
  async () =>
    await import("features/Alerts/components/InvitationTemplateApprovalAlert"),
);

const LazyDiscoveryMedicalResearchActivityAlerts = React.lazy(
  async () =>
    await import(
      "features/Alerts/components/DiscoveryMedicalResearchActivityAlert"
    ),
);

const LazyHonorariumExceptionAlerts = React.lazy(
  async () =>
    await import("features/Alerts/components/HonorariumExceptionAlert"),
);

const LazyDMCComplianceAlert = React.lazy(
  async () => await import("features/Alerts/components/DMCComplianceAlert"),
);

const LazyNewAccessAlerts = React.lazy(
  async () => await import("features/Alerts/components/NewAccessAlert"),
);

const LazyOUSApprovalAlerts = React.lazy(
  async () => await import("features/Alerts/components/OUSApprovalAlert"),
);

const LazyORFAlertsSubmitterStatus = React.lazy(
  async () =>
    await import("features/Alerts/components/ORFAlertSubmitterStatus"),
);

const LazyORFAlertsApprovalStatus = React.lazy(
  async () => await import("features/Alerts/components/ORFAlertApprovalStatus"),
);

const LazyPPQApprovalAlerts = React.lazy(
  async () => await import("features/Alerts/components/PPQApprovalAlert"),
);

const LazyPPQHoldingAreaAlert = React.lazy(
  async () => await import("features/Alerts/components/PPQHoldingAreaAlert"),
);

const LazyScreeningAlerts = React.lazy(
  async () => await import("features/Alerts/components/ScreeningAlert"),
);

const LazyVenueCatererApprovalAlerts = React.lazy(
  async () =>
    await import("features/Alerts/components/VenueCatererApprovalAlert"),
);

const LazyCoordinatoralertAlert = React.lazy(
  async () => await import("features/Alerts/components/CoordinatorAlert"),
);

const LazyActivityAlerts = React.lazy(
  async () => await import("features/Alerts/components/ActivityOwnerAlert"),
);

const LazyCostCenterAlert = React.lazy(
  async () => await import("features/Alerts/components/CostCenterAlert"),
);

const LazyARFAssigned = React.lazy(
  async () => await import("features/Alerts/components/ARFAssignedAlert"),
);

const LazyCMSManager = React.lazy(
  async () =>
    await import("features/Alerts/components/CMSManagerAdvisingRequestAlert"),
);

const LazyAdvitisingRequestForm = React.lazy(
  async () =>
    await import("features/Alerts/components/AdvisingRequestFormAlert"),
);

const LazyActivityAlert = React.lazy(
  async () => await import("features/Alerts/components/ActivityAlert"),
);
const LazyFacultyVideoAlerts = React.lazy(
  async () => await import("features/Alerts/components/FacultyVideoAlerts"),
);

const LazyFacultyW9ValidationAlerts = React.lazy(
  async () => await import("features/Alerts/components/FacultyW9ValidationFailureAlert"),
);
// Alerts End

const LazyEvaluation = React.lazy(
  async () => await import("features/Evaluation/components/Evaluation"),
);

const LazyResources = React.lazy(
  async () => await import("features/Resources/components/Resources"),
);

const LazySearchActivityResult = React.lazy(
  async () =>
    await import(
      "features/Activity/components/SearchActivities/SearchActivityResult"
    ),
);

const LazyAdvanceSearchActivity = React.lazy(
  async () =>
    await import(
      "features/Activity/components/SearchActivities/AdvanceSearchActivity"
    ),
);

const LazyListInvoiceManagement = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PaymentManagementTools/InvoiceManagement"
    ),
);
const LazyListInvoiceDetail = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PaymentManagementTools/InvoiceDetail"
    ),
);
const LazyActivityDirectionSearchResults = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/ActivityDirectionSearchResults"
    ),
);
const LazyGetDirection = React.lazy(
  async () =>
    await import("features/Activity/components/ActivityTools/GetDirection"),
);
const LazyFacultyBasicSearch = React.lazy(
  async () =>
    await import("features/Faculty/components/FacultyBasicSearchResult"),
);

const LazyFacultyBasicSearchResult = React.lazy(
  async () =>
    await import("features/Faculty/components/FacultyBasicSearchResult"),
);

const LazyFacultyAdvancedSearch = React.lazy(
  async () => await import("features/Faculty/components/FacultyAdvancedSearch"),
);

const LazyFacultyAdvancedResult = React.lazy(
  async () =>
    await import("features/Faculty/components/FacultyAdvancedSearchResult"),
);

const LazyFacultyPPQAdvancedResult = React.lazy(
  async () =>
    await import("features/Faculty/components/FacultyPPQAdvancedSearchResult"),
);

const LazyFacultyProfile = React.lazy(
  async () => await import("features/Faculty/components/FacultyTabsContainer"),
);

const LazyFacultyAddEditMyList = React.lazy(
  async () => await import("features/Faculty/components/AddEditMyList"),
);

const LazyOptInTravelPrefrences = React.lazy(
  async () => await import("features/Faculty/components/OptInTravelPrefrences"),
);

const LazyTrainingInfo = React.lazy(
  async () => await import("features/Faculty/components/TrainingInfo"),
);

const LazyFacultyMiscellaneous = React.lazy(
  async () => await import("features/Faculty/components/FacultyMiscellaneous"),
);

const LazyFacultyCvBioPicInformation = React.lazy(
  async () =>
    await import("features/Faculty/components/FacultyCvBioPicInformation"),
);

const LazyFacultySpeakerProgramPreferences = React.lazy(
  async () =>
    await import(
      "features/Faculty/components/FacultySpeakerProgramPreferences"
    ),
);

const LazyAddEditHCPAffiliationLicenses = React.lazy(
  async () =>
    await import("features/Faculty/components/AddEditHCPAffiliationLicenses"),
);

const LazyTaxForms = React.lazy(
  async () => await import("features/Faculty/components/TaxForm1099"),
);

const LazyTiering = React.lazy(
  async () => await import("features/Faculty/components/AddEditFacultyTiering"),
);

const LazyFacultyEditProfile = React.lazy(
  async () => await import("features/Faculty/components/EditProfile"),
);

const LazyFacultyRequestContactInfo = React.lazy(
  async () => await import("features/Faculty/components/FacultyContactInfo"),
);

const LazyFacultyAllocation = React.lazy(
  async () => await import("features/Faculty/components/FacultyAllocation"),
);

const LazyFacultyBrandAllocation = React.lazy(
  async () => await import("features/Faculty/components/BrandAllocation"),
);

const LazyFacultyViewNotes = React.lazy(
  async () => await import("features/Faculty/components/ViewNotes"),
);

const LazyActivityAssignment = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ActivityAssignment"
    ),
);
const LazyAddActivityAssignmentRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddActivityAssignmentRule"
    ),
);

const LazyAdminAlertPreferencesScreen = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AdminAlertPreferencesScreen"
    ),
);

const LazyMetaData = React.lazy(
  async () =>
    await import("features/Administration/components/SystemTools/MetaData"),
);

const LazyMedicalDDFields = React.lazy(
  async () =>
    await import(
      "features/Administration/components/MedicalDDField/MedicalDDFields"
    ),
);

const LazyAnnouncementEditor = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AnnouncementEditor"
    ),
);

const LazyAutomatedBusinessTasks = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AutomatedBusinessTasks"
    ),
);

const LazyContactNoteTypeConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ContactNoteTypeConfig"
    ),
);

const LazyAddEditContactNoteTypeConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditContactNoteTypeConfig"
    ),
);

const LazyContentManagement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ContentManagement"
    ),
);

const LazyContentManagementPermission = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ContentManagmentPermission"
    ),
);

const LazyEditContentManagementPermission = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ContentManagmentPermission"
    ),
);

const LazyExpenseApprovalConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ExpenseApprovalConfiguration"
    ),
);
const LazyAddExpenseApprovalConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditExpenseApprovalConfiguration"
    ),
);

const LazyExpenseApprovalExceptionEditor = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ExpenseApprovalExceptionEditor"
    ),
);

const LazyActivitySeries = React.lazy(
  async () =>
    await import("features/Administration/components/Utilities/ActivitySeries"),
);

const LazyAffiliation = React.lazy(
  async () =>
    await import("features/Administration/components/Utilities/Affiliation"),
);

const LazyAIComplianceMonitoringQueue = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/AIComplianceMonitoringQueue"
    ),
);

const LazyAIComplianceRuleConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/AIComplianceRuleConfiguration"
    ),
);

const LazyAddEditAffiliation = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/AddEditAffiliation"
    ),
);

const LazyFacultyKeyChange = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/FacultyKeyChange"
    ),
);

const LazyUpdateDocOnFile = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/UpdateDocOnFile"
    ),
);

const LazyCostCenterInsert = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/CostCenterInsert"
    ),
);

const LazyUpdateIO = React.lazy(
  async () =>
    await import("features/Administration/components/Utilities/UpdateIO"),
);

const LazyTaxTextConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Finance/TaxTextConfiguration"
    ),
);

const LazyAddEditTaxTextConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Finance/AddEditTaxTextConfiguration"
    ),
);

const LazyTaxingAuthority = React.lazy(
  async () =>
    await import("features/Administration/components/Finance/TaxingAuthority"),
);

const LazyAddEditMedicalDDFields = React.lazy(
  async () =>
    await import(
      "features/Administration/components/MedicalDDField/AddEditMedicalDDFields"
    ),
);

const LazyTax1099ReportingApproval = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Finance/1099ReportingApproval"
    ),
);

const LazySupplierList = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/SupplierList"
    ),
);

const LazyAddEditSupplier = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/SupplierInformationTab"
    ),
);

const LazyScreening = React.lazy(
  async () =>
    await import("features/Administration/components/Screening/Screening"),
);

const LazyEditScreening = React.lazy(
  async () =>
    await import("features/Administration/components/Screening/EditScreening"),
);

const LazySupplierBrandRules = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/SupplierBrandRules"
    ),
);

const LazyAddEditSupplierBrandRules = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/AddEditSupplierBrandRules"
    ),
);

const LazySupplierMapping = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/SupplierMapping"
    ),
);

const LazyAddEditSupplierMapping = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/AddEditSupplierMapping"
    ),
);

const LazyVMSFaculty = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/VmsFaculty"
    ),
);

const LazyAddEditVMSFaculty = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/AddEditVmsFaculty"
    ),
);

const LazyAddEditAnnouncementEditor = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditAnnouncementEditor"
    ),
);

const LazyArfConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/ArfConfiguration"
    ),
);

const LazyFieldAlignmentMapping = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/FieldAlignmentMapping"
    ),
);

const LazyBrandApprovers = React.lazy(
  async () =>
    await import("features/Administration/components/Brands/BrandApprovers"),
);

const LazySponsorAssignment = React.lazy(
  async () =>
    await import("features/Administration/components/Brands/SponsorAssignment"),
);

const LazyAddEditSponsorAssignment = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/AddEditSponsorAssignment"
    ),
);

const LazySpeakerProgramPreferenceConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/SpeakerProgramPreferenceConfiguration"
    ),
);

const LazyBrandsAndSubBrands = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/BrandsAndSubBrands"
    ),
);

const LazyAddEditBrandsAndSubBrands = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/AddEditBrandsAndSubBrands"
    ),
);

const LazyOUSApporvers = React.lazy(
  async () =>
    await import("features/Administration/components/Brands/OUSApprovers"),
);

const LazyTopicConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/TopicTrainingRequirementConfig"
    ),
);

const LazyAddeditTopicConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/AddEditTopicConfig"
    ),
);

const LazyTopicTrainingRequirement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Brands/TopicTrainingRequirementAdministration"
    ),
);

const LazyRequestFormConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/RequestFormConfiguration"
    ),
);

const LazyAssignerAlignment = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/AssignerAlignment"
    ),
);

const LazyFinalizeStrategicFunds = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/FinalizeStrategicFunds"
    ),
);

const LazyOwnershipLimit = React.lazy(
  async () =>
    await import("features/Administration/components/Contracts/OwnershipLimit"),
);

const LazyAddEditOwnershipLimit = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/AddEditOwnershipLimit"
    ),
);

const LazyFacultySelectionRules = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/FacultySelectionRules"
    ),
);

const LazyAddEditFacultySelectionRules = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/AddEditFacultySelectionRules"
    ),
);

const LazyAddEditAdvisingCentralmembers = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditAdvisingCentralMembersConfiguration"
    ),
);

const LazyAffiliates = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/FetchFeedbackActivityGroup"
    ),
);
const LazyAddEditAffiliates = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditFeedbackActivityGroup"
    ),
);

const LazyAddEditCredentialsForPaymentLimits = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditCredentialsForPaymentLimits"
    ),
);
const LazyAnticipatedWorkProducts = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AnticipatedWorkProducts"
    ),
);

const LazyAddEditAnticipatedWorkProducts = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditAnticipatedWorkProducts"
    ),
);

const LazyCommercialDecisionStatus = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/CommercialDecisionStatus"
    ),
);
const LazyAddEditCommercialDecisionStatus = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditCommercialDecisionStatus"
    ),
);

const LazyCommunicationTypes = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/CommunicationTypes"
    ),
);
const LazyAddEditCommunicationTypes = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditCommunicationTypes"
    ),
);

const LazyNonMedicalPersonnelAreas = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/NonMedicalPersonnelAreas"
    ),
);

const LazyAddEditNonMedicalPersonnelAreas = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditNonMedicalPersonnelAreas"
    ),
);
const LazyBusinessUnits = React.lazy(
  async () =>
    await import("features/Administration/components/AdBoard/BusinessUnits"),
);

const LazyAddEditBusinessUnits = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditBusinessUnits"
    ),
);

const LazyTherapeuticAreas = React.lazy(
  async () =>
    await import("features/Administration/components/AdBoard/TherapeuticAreas"),
);
const LazyAddEditTherapeuticAreas = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditTherapeuticAreas"
    ),
);

const LazyIndividualPaymentRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/IndividualPaymentRule"
    ),
);
const LazyAddEditIndividualPaymentRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdBoard/AddEditIndividualPaymentRule"
    ),
);
const LazyActivityAutoCancelConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ActivityAutoCancelConfiguration"
    ),
);
const LazyAddEditActivityAutoCancelConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditActivityAutoCancelConfiguration"
    ),
);
const LazySpeakerProgramPreferencesMasterUpload = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/SpeakerProgramPreferencesMasterUpload"
    ),
);
const LazyUpdateClientSponsor = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/UpdateClientSponsor"
    ),
);
const LazyAIComplianceReview = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/AIComplianceReview"
    ),
);
const LazyAddEditAIComplianceReview = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/AddEditAIComplianceReview"
    ),
);
const LazyAddEditAIComplianceRuleConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Utilities/AddEditAIComplianceRuleConfiguration"
    ),
);
const LazyContractTemplate = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/ContractTemplate"
    ),
);
const LazyContractTemplateDetail = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/ContractTemplateDetail"
    ),
);
const LazySupplierUsers = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/SupplierUserListTab"
    ),
);

const LazySupplierComments = React.lazy(
  async () =>
    await import(
      "features/Administration/components/SupplierAdminTools/SupplierCommentsTab"
    ),
);

const LazyCredentialsAndSpecialties = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/CredentialsAndSpecialties"
    ),
);

const LazyAddEditCredentials = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditCredentials"
    ),
);

const LazyListActivityDescriptions = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListActivityDescriptions"
    ),
);
const LazyActivityTab = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ActivityTabs"
    ),
);

const LazyListActivityRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListActivityRule"
    ),
);
const LazyActivityRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ActivityRule"
    ),
);
const LazyListAttendeeRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListAttendeeRule"
    ),
);
const LazyListAttendeeProgramCapRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListAttendeeProgramCapRule"
    ),
);
const LazyAttendeeProgramCapRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AttendeeProgramCapRule"
    ),
);
const LazyAttendeeAsTrainedRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AttendeeAsTrainedRule"
    ),
);
const LazyFrContentConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/FrContentConfig"
    ),
);

const LazyFRContentConfigAddNewGroup = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/FRContentConfigAddNewGroup"
    ),
);

const LazyExcludedApprovers = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ExcludedApprovers"
    ),
);

const LazyAddEditExcludedApprovers = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditExcludedApprovers"
    ),
);

const LazyFRContentAssociations = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/FRContentAssociations"
    ),
);

const LazyAddEditFRContentAssociations = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditFRContentAssociations"
    ),
);

const LazyContractManagement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Contracts/ContractManagement"
    ),
);

const LazyGroupingConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/GroupingConfiguration"
    ),
);

const LazyListUserGroup = React.lazy(
  async () =>
    await import("features/Administration/components/AdminTools/ListUserGroup"),
);

const LazyAddEditListUserGroup = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditListUserGroup"
    ),
);

const LazyListUserGroupDivisionMappingRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ListUserGroupDivisionMappingRule"
    ),
);

const LazyAddEditListUserGroupDivisionMappingRule = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditListUserGroupDivisionMappingRule"
    ),
);

const LazyStateGuidelines = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/StateGuidelines"
    ),
);

const LazyAddEditStateGuidelines = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditStateGuidelines"
    ),
);

const LazyAddEditGroupingConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditGroupingConfiguration"
    ),
);

const LazyInvitationTemplates = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/InvitationTemplates"
    ),
);

const LazyAddEditInvitationTemplate = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditInvitationTemplate"
    ),
);

const LazyExpenseManagement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ExpenseManagement"
    ),
);

const LazyAddEditExpenseManagement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditExpenseManagement"
    ),
);

const LazyUserManagement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/UserManagement"
    ),
);

const LazyAddEditUserManagement = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditUserManagment"
    ),
);

const LazyRepEvaluationConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/RepEvaluationConfig"
    ),
);

const LazyAddEditRepEvaluationConfig = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditRepEvaluationConfig"
    ),
);

const LazyCorrespondence = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/Correspondence"
    ),
);

const LazyAddEditEmailNotification = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditEmailNotification"
    ),
);

const LazySpecialtyGroup = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/SpecialtyGroup"
    ),
);

const LazyAddSpecialtyGroup = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddSpecialtyGroup"
    ),
);
const LazyListTasks = React.lazy(
  async () =>
    await import("features/Administration/components/AdminTools/ListTasks"),
);
const LazyAddEditTask = React.lazy(
  async () =>
    await import("features/Administration/components/AdminTools/AddEditTask"),
);
const LazyViewTextMsgAlerts = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/ViewTextMsgAlerts"
    ),
);
const LazyAddEditTextMsgAlert = React.lazy(
  async () =>
    await import(
      "features/Administration/components/AdminTools/AddEditTextMsgAlert"
    ),
);
const LazyBudgetExemption = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/BudgetExemption"
    ),
);
const LazyAddEditBudgetExemption = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditBudgetExemption"
    ),
);
const LazyBusinessJustification = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/BusinessJustification"
    ),
);
const LazyAddEditBusinessJustification = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditBusinessJustification"
    ),
);
const LazyChangeActivityDescription = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ChangeActivityDescription"
    ),
);
const LazyFacultySelection = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/FacultySelection"
    ),
);
const LazyAddEditFacultySelection = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditFacultySelection"
    ),
);
const LazyListAdvHonorarium = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListAdvHonorarium"
    ),
);
const LazyAdvHonorarium = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AdvHonorarium"
    ),
);
const LazyListMedicalHonorarium = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListMedicalHonorarium"
    ),
);
const LazyMedicalHonorarium = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/MedicalHonorarium"
    ),
);
const LazyTravelHonorariumSearch = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/TravelHonorariumSearch"
    ),
);
const LazyAddEditHonorariumTravelRules = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditHonorariumTravelRules"
    ),
);

const LazyTierBrandMapping = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/TierBrandMapping"
    ),
);

const LazyAddEditTierBrandMapping = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditTierBrandMapping"
    ),
);
const LazyMedicalTierAdmin = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/MedicalTierAdmin"
    ),
);
const LazyListHonorarium = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/ListHonorarium"
    ),
);
const LazyHonorarium = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/Honorarium"
    ),
);
const LazyHonorariumAdmin = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/HonorariumAdmin"
    ),
);
const LazyAddEditHonorariumAdmin = React.lazy(
  async () =>
    await import(
      "features/Administration/components/ActivityConfiguration/AddEditHonorariumAdmin"
    ),
);

const LazyAddExpenseDetail = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PaymentManagementTools/AddExpenseDetail"
    ),
);

const LazyAddEditExpenseDetail = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PaymentManagementTools/AddEditExpenseDetail"
    ),
);

const LazySearchARFResult = React.lazy(
  async () =>
    await import("features/Activity/components/SearchARF/SearchARFResult"),
);

const LazyAdvanceSearchARF = React.lazy(
  async () =>
    await import("features/Activity/components/SearchARF/AdvanceSearchARF"),
);
const LazyAddFieldActivity = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/AddFieldActivity/AddFieldActivity"
    ),
);
const LazyAddAdvisingActivity = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/AddActivity/AddAdvisingActivity"
    ),
);
const LazyAddBrandActivity = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/AddActivity/AddBrandActivity"
    ),
);
const LazySelectActivityType = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityTools/AddActivity/SelectActivityType"
    ),
);
const LazyExpenseCorrespondence = React.lazy(
  async () =>
    await import(
      "features/Activity/components/PymtMgmtTools/ExpenseCorrespondence"
    ),
);

const LazyActivityCalendar = React.lazy(
  async () =>
    await import(
      "features/Activity/components/ActivityCalendar/ActivityCalendar"
    ),
);
const LazySurveyQuestions = React.lazy(
  async () =>
    await import("features/Administration/components/Survey/SurveyQuestions"),
);
const LazyAddEditSurveyQuestions = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Survey/AddEditSurveyQuestion"
    ),
);

const LazySurveyBusinessUnits = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Survey/SurveyBusinessUnits"
    ),
);
const LazyAddEditSurveyBusinessUnits = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Survey/AddEditSurveyBusinessUnits"
    ),
);

const LazySurveyConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Survey/SurveyConfiguration"
    ),
);
const LazyAddEditSurveyConfiguration = React.lazy(
  async () =>
    await import(
      "features/Administration/components/Survey/AddEditSurveyConfiguration"
    ),
);
const LazyDashboardSurvey = React.lazy(
  async () => await import("features/Dashboard/components/Dashboard"),
);

const LazyHCPRegistrationAdmin = React.lazy(
  async () => await import("features/Activity/components/ActivityTools/AddActivity/HCPRegistrationAdmin"),
);
const MainRoutes = {
  element: <MasterLayout />,
  children: [
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/dashboard/:type",
      element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyDashboardSurvey />
            </React.Suspense>
          ),
    },
    {
      path: "/faculty",
      element: <Faculty />,
      children: [
        {
          path: "/faculty/facultydetails",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyProfile />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultybasicsearch",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyBasicSearch />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultybasicsearchresults",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyBasicSearchResult />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultyadvancesearchresults",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyAdvancedResult />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultyadvancedsearch",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyAdvancedSearch />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultyppqadvancesearchresults",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyPPQAdvancedResult />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyProfile />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/viewmylist",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyViewMyList />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/viewmylist/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyAddEditMyList />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/preferences",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyOptInTravelPrefrences />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/addeditfacultytiering",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTiering />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/traininginfo",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTrainingInfo />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultymiscellaneous",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyMiscellaneous />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultycvbiopicinformation",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyCvBioPicInformation />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/speakerprogrampreferences",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultySpeakerProgramPreferences />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/taxform1099",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTaxForms />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/addedithcpaffiliationlicenses",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditHCPAffiliationLicenses />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultytypeselection",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyTypeSelection />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultyrequestprofile",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyRequestProfile />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/addnonhcpandpatient",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddNonHCPAndPatient />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/searchvenuecaterer",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySearchVenueCaterer />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/addeditvenuecaterer",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditVenueCaterer />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/addmultiplefaculty",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddMultipleFaculty />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/editprofile",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyEditProfile />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultyrequestcontactinfo",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyRequestContactInfo />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/facultyallocation",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyAllocation />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/brandallocation",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyBrandAllocation />
            </React.Suspense>
          ),
        },
        {
          path: "/faculty/viewNotes",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyViewNotes />
            </React.Suspense>
          ),
        },
      ],
    },
    {
      path: "/activity",
      element: <Activity />,
      children: [
        {
          path: "/activity/selectbrandormedicalactivitytype",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySelectBrandOrMedicalActivityType />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/medicalactivity",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyMedicalActivity />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/activitycalendar",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityCalendar />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/searchactivity",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySearchActivityResult />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/searchactivityresult",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySearchActivityResult />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/advancesearchactivity",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdvanceSearchActivity />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/activitydirectionsearch",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdvanceSearchActivity />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/facultybasicsearch",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyBasicSearch />
            </React.Suspense>
          ),
        },

        {
          path: "/activity/facultybasicsearchresults",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyBasicSearchResult />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/facultyadvancedsearch",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyAdvancedSearch />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/facultyadvancesearchresults",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyAdvancedResult />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/searchvenuecaterer",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySearchVenueCaterer />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/addeditvenuecaterer",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditVenueCaterer />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/invoicemanagement",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListInvoiceManagement />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/invoicemanagement/invoicedetails",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListInvoiceDetail />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/activitydirectionsearchresults",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityDirectionSearchResults />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/direction",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyGetDirection />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/expensemanagement",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddExpenseDetail />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/expensemanagement/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditExpenseDetail />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/paymentrequest",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyPaymentRequest />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/activitymeetings",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityMeetings />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/sendcorrespondence",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySendCorrespondence />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/activitymap",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityMap />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/activityhistory",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityHistory />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/checkstatus",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCheckStatus />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/searcharf",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySearchARFResult />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/searcharfresult",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySearchARFResult />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/advancesearcharf",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdvanceSearchARF />
              {/* <LazyAddFieldActivity /> */}
            </React.Suspense>
          ),
        },
        {
          path: "/activity/fieldactivity",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddFieldActivity />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/advisingactivity",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddAdvisingActivity />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/brandactivity",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddBrandActivity />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/selectactivitytype",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySelectActivityType />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/expensecorrespondence",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyExpenseCorrespondence />
            </React.Suspense>
          ),
        },
        {
          path: "/activity/hcpregistrationadmin",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyHCPRegistrationAdmin />
            </React.Suspense>
          ),
        },
      ],
    },

    {
      path: "/reports",
      element: <Reports />,
      children: [
        {
          path: "/reports/reportcriteria",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyReportCriteria />
            </React.Suspense>
          ),
        },
        {
          path: "/reports/myscheduledreports",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyMyScheduledReports />
            </React.Suspense>
          ),
        },
      ],
    },
    {
      path: "/alerts",
      element: <Alerts />,
      children: [
        {
          path: "/alerts/activityalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/activityowneralert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/additionalcompensationalert2009",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdditionalCompensationAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/budgetapprovalalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyBudgetApprovalAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/coordinatoralert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCoordinatoralertAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/facultyapprovalalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyApprovalAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/cvbioalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyCVAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/faapprovalalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdvisoryBoardSingleActivityAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/frcoordinatorfacultyrequestalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyApprovedFacultyRequestAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/honorariumexceptionalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyHonorariumExceptionAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/invitationtemplatealert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyInvitationTemplateApprovalAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/medicalapprovalalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyDiscoveryMedicalResearchActivityAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/dmccompliancealert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyDMCComplianceAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/newuseralert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyNewAccessAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/ousapprovalalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyOUSApprovalAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/orfalertsubmitterstatus",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyORFAlertsSubmitterStatus />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/orfalertsapprovalstatus",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyORFAlertsApprovalStatus />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/ppqapprovalalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyPPQApprovalAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/ppqholdingarea",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyPPQHoldingAreaAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/facultyscreeningalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyScreeningAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/venuecatererapprovalalerts",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyVenueCatererApprovalAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/advisingrequestformalert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdvitisingRequestForm />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/cmsmanageralert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCMSManager />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/assignedcmscontact",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyARFAssigned />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/costcenteralert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCostCenterAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/alerts/facultyvideoalerts",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyVideoAlerts />
            </React.Suspense>
          ),
        },
           {
          path: "/alerts/facultyw9validationfailurealert",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyW9ValidationAlerts />
            </React.Suspense>
          ),
        },
      ],
    },
    {
      path: "/evaluation",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyEvaluation />
        </React.Suspense>
      ),
    },
    {
      path: "/resources/resourcemanagement",
      element: (
        <React.Suspense fallback={<Loader open={true} />}>
          <LazyResources />
        </React.Suspense>
      ),
    },
    {
      path: "/administration",
      element: <Administration />,
      children: [
        {
          path: "/administration/activityassignment",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityAssignment />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/activityassignment/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddActivityAssignmentRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/alertconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdminAlertPreferencesScreen />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/metadata",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyMetaData />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listmedicalddfields",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyMedicalDDFields />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/announcement",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAnnouncementEditor />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/automatedbusinesstasks",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAutomatedBusinessTasks />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/viewcontactnotetype",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyContactNoteTypeConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/viewcontactnotetype/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditContactNoteTypeConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/resourcemanagement",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyContentManagement />
            </React.Suspense>
          ),
        },
         {
          path: "/administration/expenseapprovalconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyExpenseApprovalConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/expenseapprovalconfiguration/exceptioneditor",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyExpenseApprovalExceptionEditor />
            </React.Suspense>
          ),
         },
        {
          path: "/administration/expenseapprovalconfiguration/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddExpenseApprovalConfiguration />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/resourcemanagement/permission",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyContentManagementPermission />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/resourcemanagement/permission/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyEditContentManagementPermission />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/updateactivityseries",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivitySeries />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/aicompliancemonitoringqueue",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAIComplianceMonitoringQueue />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/aicomplianceruleconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAIComplianceRuleConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/affiliation",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAffiliation />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/affiliation/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAffiliation />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/updatefacultykey",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultyKeyChange />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/updatedoconfile",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyUpdateDocOnFile />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/insertcostcenter",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCostCenterInsert />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/updateio",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyUpdateIO />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/taxtextconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTaxTextConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/taxtextconfiguration/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditTaxTextConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/taxingauthority",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTaxingAuthority />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listmedicalddfields/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditMedicalDDFields />
            </React.Suspense>
          ),
        },
        // {
        //   path: "/administration/taxtextconfiguration",
        //   element: (
        //     <React.Suspense fallback={<Loader open={true} />}>
        //       <LazyTaxTextConfiguration />
        //     </React.Suspense>
        //   ),
        // },
        {
          path: "/administration/1099ReportingApproval",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTax1099ReportingApproval />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/supplierlist",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySupplierList />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/supplier",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSupplier />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/individualscreening",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyScreening />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/individualscreeningdetail",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyEditScreening />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/supplierbrandrules",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySupplierBrandRules />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/supplierbrandrules/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSupplierBrandRules />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/suppliermapping",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySupplierMapping />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/suppliermapping/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSupplierMapping />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/vmsfaculty",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyVMSFaculty />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/vmsfaculty/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditVMSFaculty />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/announcement/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAnnouncementEditor />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/orfconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyArfConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/mapfieldownership",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFieldAlignmentMapping />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/brandapprovers",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyBrandApprovers />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/sponsorassignment",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySponsorAssignment />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/sponsorassignment/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSponsorAssignment />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/speakerprogrampreferenceconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySpeakerProgramPreferenceConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/brandsandsubbrands",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyBrandsAndSubBrands />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/brandsandsubbrands/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditBrandsAndSubBrands />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/approver",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyOUSApporvers />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/topicconfig",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTopicConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/topicconfig/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddeditTopicConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/topictrainingrequirement",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTopicTrainingRequirement />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/requestformconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyRequestFormConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/assigneralignment",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAssignerAlignment />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/finalizestrategicfunds",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFinalizeStrategicFunds />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/ownershiplimit",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyOwnershipLimit />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/ownershiplimit/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditOwnershipLimit />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/rules",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultySelectionRules />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/rules/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditFacultySelectionRules />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listalliancegroupbrand",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTierBrandMapping />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listalliancegroupbrand/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditTierBrandMapping />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/medicaltierextend",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyMedicalTierAdmin />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/addeditadvisingcentralmembersconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAdvisingCentralmembers />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/affiliates",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAffiliates />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/affiliates/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAffiliates />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/addeditcredentialsforpaymentlimits",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditCredentialsForPaymentLimits />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/anticipatedworkproducts",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAnticipatedWorkProducts />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/anticipatedworkproducts/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAnticipatedWorkProducts />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/commercialdecisionstatus",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCommercialDecisionStatus />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/commercialdecisionstatus/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditCommercialDecisionStatus />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/communicationtypes",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCommunicationTypes />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/communicationtypes/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditCommunicationTypes />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/nonmedicalpersonnelareas",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyNonMedicalPersonnelAreas />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/nonmedicalpersonnelareas/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditNonMedicalPersonnelAreas />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/businessunits",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyBusinessUnits />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/businessunits/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditBusinessUnits />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/therapeuticareas",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTherapeuticAreas />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/therapeuticareas/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditTherapeuticAreas />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/individualpaymentrule",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyIndividualPaymentRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/individualpaymentrule/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditIndividualPaymentRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/activityautocancelconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityAutoCancelConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/activityautocancelconfiguration/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditActivityAutoCancelConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/speakerprogrampreferencesmasterupload",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySpeakerProgramPreferencesMasterUpload />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/updateclientsponsor",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyUpdateClientSponsor />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/contracttemplate",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyContractTemplate />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/contracttemplate/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyContractTemplateDetail />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/supplieruserlist",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySupplierUsers />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/suppliercomments",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySupplierComments />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listcredentialsspecialities",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCredentialsAndSpecialties />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listcredentialsspecialities/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditCredentials />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listactivitydescriptions",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListActivityDescriptions />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listactivitydescriptions/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityTab />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listactivityrule",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListActivityRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listactivityrule/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyActivityRule />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/listattendeerule",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListAttendeeRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listattendeerule/listattendeeprogramcapRule",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListAttendeeProgramCapRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listattendeerule/listattendeeprogramcapRule/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAttendeeProgramCapRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listattendeerule/attendeeastrainedrule",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAttendeeAsTrainedRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/frcontentconfig",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFrContentConfig />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/frcontentconfig/frcontentaddnewgroup",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFRContentConfigAddNewGroup />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/frcontentconfig/frcontenteditgroup",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFRContentConfigAddNewGroup />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listexcludedapprovers",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyExcludedApprovers />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listexcludedapprovers/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditExcludedApprovers />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/frcontentassociations",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFRContentAssociations />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/frcontentassociations/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditFRContentAssociations />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/contractmanagement",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyContractManagement />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listgroupingconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyGroupingConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listusergroup",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListUserGroup />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listusergroup/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditListUserGroup />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listusergroupdivisionmappingrule/",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListUserGroupDivisionMappingRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listusergroupdivisionmappingrule/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditListUserGroupDivisionMappingRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/liststateguidelines",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyStateGuidelines />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/stateguidelines/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditStateGuidelines />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/groupingconfiguration/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditGroupingConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listinvitationtemplate",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyInvitationTemplates />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/invitationtemplate/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditInvitationTemplate />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/searchexpenserule",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyExpenseManagement />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/searchexpenserule/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditExpenseManagement />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listusergroupdivisionmappingrule/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditListUserGroupDivisionMappingRule />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/searchuser/",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyUserManagement />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/searchuser/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditUserManagement />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/liststateguidelines",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyStateGuidelines />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listrepevaluationconfigrules",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyRepEvaluationConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listrepevaluationconfigrules/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditRepEvaluationConfig />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/correspondence",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyCorrespondence />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/correspondence/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditEmailNotification />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/specialtygroup",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySpecialtyGroup />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/specialtygroup/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddSpecialtyGroup />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listtasks",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListTasks />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listtasks/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditTask />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/viewtextmsgalerts",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyViewTextMsgAlerts />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/viewtextmsgalerts/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditTextMsgAlert />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listbudgetexemption",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyBudgetExemption />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listbudgetexemption/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditBudgetExemption />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/businessjustification",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyBusinessJustification />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/businessjustification/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditBusinessJustification />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/updateactivitydescription",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyChangeActivityDescription />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listfacultyselection",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyFacultySelection />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listfacultyselection/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditFacultySelection />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listadvhonorarium",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListAdvHonorarium />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/listadvhonorarium/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAdvHonorarium />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listmedicalhonorarium",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListMedicalHonorarium />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/listmedicalhonorarium/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyMedicalHonorarium />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/travelhonorariumsearch",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyTravelHonorariumSearch />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/travelhonorariumsearch/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditHonorariumTravelRules />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/listhonorarium",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyListHonorarium />
            </React.Suspense>
          ),
        },

        {
          path: "/administration/listhonorarium/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyHonorarium />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/honorariumadmin",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyHonorariumAdmin />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/honorariumadmin/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditHonorariumAdmin />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/aicompliancefindingreview",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAIComplianceReview />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/aicompliancefindingreview/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAIComplianceReview />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/aicomplianceruleconfiguration/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditAIComplianceRuleConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/surveyquestions",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySurveyQuestions />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/surveyquestions/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSurveyQuestions />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/surveybusinessunits",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySurveyBusinessUnits />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/surveybusinessunits/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSurveyBusinessUnits />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/surveyconfiguration",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazySurveyConfiguration />
            </React.Suspense>
          ),
        },
        {
          path: "/administration/surveyconfiguration/:type",
          element: (
            <React.Suspense fallback={<Loader open={true} />}>
              <LazyAddEditSurveyConfiguration />
            </React.Suspense>
          ),
        },
      ],
    },
  ],
};

export default MainRoutes;
